import {
    INTEGRATION_GET_CHANNEL_ACCOUNT_BEGIN,
    INTEGRATION_GET_CHANNEL_ACCOUNT_SUCCESS,
    INTEGRATION_GET_CHANNEL_ACCOUNT_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function getPublishAccount(channelId) {
    return async dispatch => {
        dispatch({
            type: INTEGRATION_GET_CHANNEL_ACCOUNT_BEGIN
        })
        try {
            const res = await BFFAgent.Integrations.getSalesChannel()
            const channelAccountList = res.data.data.find(account => account.id === channelId)
                .integrationAccounts.map(account => (
                {
                    value: account.id,
                    label: account.config.name,
                    description: account.config.description,
                    images: account.config.images || [],
                    status: account.status,
                    video_url: account.config.video_uri,
                    config: {
                        address: account.config?.address,
                        zip_code: account.config?.zip_code,
                        cellphone: account.config?.cellphone,
                        telephone: account.config?.telephone,
                        country_id: account.config?.country_id,
                        location_id: account.config?.location_id,
                        province_id: account.config?.province_id,
                        working_hours: account.config?.working_hours,
                        neighborhood_id: account.config?.neighborhood_id,
                    },
                    // Agregar en este objeto cualquier otro dato de cuenta necesario para el componente que lo llama
                }))
            dispatch({
                type: INTEGRATION_GET_CHANNEL_ACCOUNT_SUCCESS,
                data: channelAccountList
            })

        } catch {
            dispatch({
                type: INTEGRATION_GET_CHANNEL_ACCOUNT_FAILURE
            })
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_GET_CHANNEL_ACCOUNT_BEGIN:
            return {
                ...state,
                isPending: true,
                error: undefined
            }

        case INTEGRATION_GET_CHANNEL_ACCOUNT_SUCCESS:
            return {
                ...state,
                isPending: false,
                error: false,
                publishAccounts: action.data
            }

        case INTEGRATION_GET_CHANNEL_ACCOUNT_FAILURE:
            return {
                ...state,
                isPending: false,
                error: true
            }

        default:
            return state
    }
}
  